import { faCalendar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format } from 'date-fns';
import { ComponentProps } from 'preact';
import { useMemo, useState } from 'preact/hooks';

import { useLatestActiveTime } from '@/hooks/useLatestActiveDateTime';
import { cn } from '@/lib/utils';

interface MediaScheduleTagProps extends ComponentProps<'div'> {
  publishedAt?: string;
}

const DefaultContent = ({ publishedAt, now }: { publishedAt: number; now: number }) => {
  const [shouldDisplayDate, setShouldDisplayDate] = useState(true);
  let msLeft = publishedAt ? publishedAt - now : 0;
  const daysLeft = Math.floor(msLeft / (1000 * 60 * 60 * 24));
  msLeft %= 1000 * 60 * 60 * 24;
  const hoursLeft = Math.floor(msLeft / (1000 * 60 * 60));
  msLeft %= 1000 * 60 * 60;
  const minutesLeft = Math.floor(msLeft / (1000 * 60));

  return (
    <button
      type="button"
      className="preflight preflight-button rounded-md bg-yellow-100 p-2 text-xs text-yellow-600"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setShouldDisplayDate(!shouldDisplayDate);
      }}
    >
      <FontAwesomeIcon icon={faCalendar} />{' '}
      {shouldDisplayDate ? format(publishedAt, 'MMM d, yyyy h:mm a') : `${daysLeft}d ${hoursLeft}h ${minutesLeft}m`}
    </button>
  );
};

const MediaScheduleTag = ({ publishedAt: publishedAtProp, className, children, ...props }: MediaScheduleTagProps) => {
  const publishedAt = useMemo(() => (publishedAtProp ? Date.parse(publishedAtProp) : null), [publishedAtProp]);
  const [now] = useLatestActiveTime();
  const isPublished = publishedAt ? now > publishedAt : true;

  return isPublished || !publishedAt ? null : (
    <div
      className={cn('absolute left-2 top-2', className)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children ?? <DefaultContent publishedAt={publishedAt} now={now} />}
    </div>
  );
};

export default MediaScheduleTag;
